// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
// Same build vue-sweetalert2 loads, so both share one instance
import swal from 'sweetalert2/dist/sweetalert2.min.js'
import Nav from './components/Nav.vue'
import NotificationBell from './components/notifications/NotificationBell.vue'
import NotificationToasts from './components/notifications/NotificationToasts.vue'
import NotificationBanner from './components/notifications/NotificationBanner.vue'
import { connectNotifications } from '../utils/notifications'
import router from './router'
import store from './store/index'
import Vuelidate from 'vuelidate'
import ResetInput from 'v-reset-input'
import BlockUI from 'vue-blockui'
import VueGoodTablePlugin from 'vue-good-table'
import TextareaAutosize from 'vue-textarea-autosize'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import './assets/nivi-treeselect.css'
import NvSelect from './components/common/NvSelect.vue'
import NvEmptyState from './components/common/NvEmptyState.vue'
import installSuccessToasts from './plugins/successToasts'
import installGoodTableDefaults from './plugins/goodTableDefaults'
import installUnsavedChanges from './plugins/unsavedChanges'
import { pageTitle } from './router/pageTitles'

// Vue.config.productionTip = false
// Plain success dialogs become corner toasts; must be set up before VueSweetalert2
installSuccessToasts(Vue, swal)
Vue.use(VueSweetalert2)
Vue.use(Vuelidate)
Vue.use(ResetInput)
Vue.use(VueGoodTablePlugin)
Vue.use(BlockUI)
Vue.use(TextareaAutosize)
// Searchable drop-in for native <select> across the app
Vue.component('nv-select', NvSelect)
Vue.component('nv-empty-state', NvEmptyState)
// Shared rows-per-page choices and remembered table settings (must run after VueGoodTablePlugin)
installGoodTableDefaults(Vue)
installUnsavedChanges(Vue, router)

/* eslint-disable no-new */

new Vue({
  el: '#nivi-app',
  router,
  store,
  components: {
    'app-nav': Nav,
    'notification-bell': NotificationBell,
    'notification-toasts': NotificationToasts,
    'notification-banner': NotificationBanner
  }
})

// Opens the notification connection once there's a logged-in user: on load, or after the
// Auth0 callback route stores the token. Does nothing if it's already open. The first
// navigation has usually finished by the time afterEach is registered, hence the direct call.
// Fade out the boot splash from index.html now that the app is on screen.
const bootSplash = document.getElementById('nv-boot')
if (bootSplash) {
  bootSplash.classList.add('nv-boot-done')
  setTimeout(() => bootSplash.remove(), 300)
}

connectNotifications()
router.afterEach(() => connectNotifications())

// Name each browser tab after its page
document.title = pageTitle(router.currentRoute)
router.afterEach(to => { document.title = pageTitle(to) })



// WEBPACK FOOTER //
// ./src/main.js